'use strict';

//Utility
var React = require('react');
var ClassNames = require('classnames');
var Mapper = require('../../utils/Mapper.js');
var _ = require('lodash');
//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var YesNoRadioData = ApplicationConstants.YesNoRadioData;
var YesNoValues = ApplicationConstants.YesNoValues;
//Actions
var OnlineAccessActions = require('../../actions/OnlineAccessActions.js');
//Components
var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var SelectInput = require('../Common/SelectInput.jsx');
//var Spinner = require('../Common/Spinner.jsx');

var OnlineAccess = React.createClass({
    getInitialState: function () {
        return {
            pinFieldName: 'pin',
            confirmPinFieldName: 'confirmPin',
            secretQuestionFieldName: 'secretQuestion',
            secretAnswerFieldName: 'secretAnswer',
            confirmSecretAnswerFieldName: 'confirmSecretAnswer',
            secretQuestions: Mapper.arrayToReactSelectOptions(this.props.content.onlineAccess.secretQuestions),
            sent: false
        };
    },

    componentWillReceiveProps: function (nextProps) {
        if (!this.props.content && nextProps.content) {
            this.setState({ secretQuestions: Mapper.arrayToReactSelectOptions(nextProps.content.onlineAccess.secretQuestions) });
        }
        const nextPinContainsError = _.some(nextProps.errorList, { id: this._createId(this.state.pinFieldName) });
        if (this.props.data.pin !== nextProps.data.pin && !nextPinContainsError ) {
            // do validation on server side if pin changes and no client side validation error detected
            OnlineAccessActions.validatePin(nextProps.data.pin, nextProps.index);
        }
    },

    handleSecretQuestionOnBlur: function (event) {
        var secretQuestion = _.find(this.state.secretQuestions, { value: event.target.value }) || {};
        OnlineAccessActions.saveOnlineAccess(event.target.model, event.target.id, secretQuestion.label || '', this.props.index);
    },

    saveOnlineAccess: function (event) {
        OnlineAccessActions.saveOnlineAccess(event.target.model, event.target.id, event.target.value, this.props.index);
    },

    savePin: function (event) {
        OnlineAccessActions.saveOnlineAccess(event.target.model, event.target.id, event.target.value, this.props.index);
        
    },

    _createId(fieldName){
      return 'oa' + fieldName + this.props.index;
    },

    render: function () {
        var publicSiteAccess = null;
        var onlineAccessContent = (this.props.content) ? this.props.content.onlineAccess : {};
        
        if (!window.NOA.userContext.oin && this.props.data.grantOnlineAccess === YesNoValues.YES) {
            var secretQuestion = _.find(this.state.secretQuestions, {label: this.props.data.secretQuestion});
            publicSiteAccess = <div>
                                    <TextInput id={this._createId(this.state.pinFieldName)}
                                               label="Enter a PIN"
                                               className="form-pin"
                                               value={this.props.data.pin}
                                               onBlur={this.savePin}
                                               type="password"
                                               model="pin"
                                               copyText={onlineAccessContent.pinCopy}
                                               errorList={this.props.errorList}
                                               isLoadingComplete={this.props.data.isLoadingComplete} />{this.props.data.isLoadingComplete ? null : (<br />)}
                                    <TextInput id={this._createId(this.state.confirmPinFieldName)}
                                               label="Confirm PIN"
                                               className="form-pin"
                                               value={this.props.data.confirmPin}
                                               onBlur={this.saveOnlineAccess}
                                               type="password"
                                               model="confirmPin"
                                               bottomText={onlineAccessContent.pinNoteCopy}
                                               errorList={this.props.errorList} />
                                    <SelectInput id={this._createId(this.state.secretQuestionFieldName)}
                                                 className="secret-question"
                                                 label="Select a secret question"
                                                 value={(secretQuestion) ? secretQuestion.value : ''}
                                                 searchable={false}
                                                 clearable={false}
                                                 onChange={this.handleSecretQuestionOnBlur}
                                                 options={this.state.secretQuestions}
                                                 model="secretQuestion"
                                                 helpText={onlineAccessContent.secretQuestionHelp} 
                                                 errorList={this.props.errorList} />
                                    <TextInput id={this._createId(this.state.secretAnswerFieldName)}
                                               label="Enter secret answer"
                                               className="form-input-wide"
                                               value={this.props.data.secretAnswer}
                                               onBlur={this.saveOnlineAccess}
                                               model="secretAnswer"
                                               errorList={this.props.errorList} />
                                    <TextInput id={this._createId(this.state.confirmSecretAnswerFieldName)}
                                               label="Confirm secret answer"
                                               className="form-input-wide"
                                               value={this.props.data.confirmSecretAnswer}
                                               onBlur={this.saveOnlineAccess}
                                               model="confirmSecretAnswer"
                                               errorList={this.props.errorList} />
            </div>;

        }
        
        return (
                <div className={ClassNames({'sub-section': Boolean(this.props.investorName)})}>
                    {this.props.investorName ? <h4>{this.props.investorName}</h4> : null}
                    <div>
                        <RadioInput id={this._createId('grantOnlineAccess')}
                                    data={YesNoRadioData}
                                    value={this.props.data.grantOnlineAccess}
                                    label="Would you like to view and transact on your investment online through FirstNet?"
                                    onChange={this.saveOnlineAccess}
                                    model="grantOnlineAccess"
                                    isValid={true} />
                    </div>
                    {publicSiteAccess}
                </div>
        );
    }
});

module.exports = OnlineAccess;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/OnlineAccess/OnlineAccess.jsx